import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  //FormControlLabel,
  IconButton,
  //Switch,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { LocationAvailabilitiesBeachChairsStyle } from "../../utils/hooks/styles/locationAvailabilitiesBeachChairsStyle";
import { useSelector } from "react-redux";
import {
  getDateFromSelector,
  getDateToSelector,
  getIsSubSectionsSelector,
  mainComponentShowSelector,
} from "../../store/selectors/mainAppSelectors";
import { getVendorSelector } from "../../store/selectors/vendorSelectors";
import {
  //AvailabilitiesBeachChairTimeline,
  SBColor,
} from "./availabilitiesBeachChair/availabilitiesBeachChairTimeline";
import AvailabilitiesBeachChairs from "./availabilitiesBeachChair/availabilitiesBeachChairs";
import Waves from "../static/waves";
import React, { useMemo, useState } from "react";
import { useAppDispatch } from "../../store";
import {
  //CalendarMonth
  Close,
  //, Grid3x3
} from "@mui/icons-material";
import { setMapStateRequest } from "../../store/reducers/mapReducer";
import { mainComponentShowChangeRequest } from "../../store/reducers/mainAppReducer";
import { EMapState } from "../../utils/models/EMapState";
import { useTranslation } from "react-i18next";
import {
  getSelectedSectionLeadTimeHoursSelector,
  getSelectedSectionSelector,
} from "../../store/selectors/sectionSelectors";
import {
  getSectionsSelector,
  getPendingAvailabilitiesSelector,
  getOutOfSeasonSelector,
} from "../../store/selectors/availabilitySelectors";
import { getPublicReferenceSelector } from "../../store/selectors/bookingSelectors";
import { getPublicSectionsBeachChairsAvailabilityRequest } from "../../store/reducers/availabilityReducer";
import dayjs from "dayjs";
import { isValidDate } from "../../utils/checkers/isValidDate";
import "dayjs/locale/de";
import { PublicVendorResponseDto } from "../../api-client/generated";
import { getPreBookingInfo } from "../../utils/functions/bookingStart";
dayjs.locale("de");
export const formatDate = (year: Number, season: String) => {
  const seasonMonthDay = season.split("-");
  return new Date(+year, +seasonMonthDay[1] - 1, +seasonMonthDay[0]);
};

const SeasonInformation = ({
  //switchTimeline,
  sectionSeasonStartInfo,
  vendorSeasonStartInfo,
  seasonStartDate,
  seasonYear,
  seasonStartEndDisplay,
  thisYearSesonStart,
  thisYearSesonEnd,
  isBeforeSeasonStart,
  locationFirstAvailableDate,
  noAvailableBeachChairs,
  vendor,
  pendingAvailabilities,
}: {
  //switchTimeline: boolean;
  sectionSeasonStartInfo?: { en: string; de: string };
  vendorSeasonStartInfo?: { en: string; de: string };
  seasonStartDate?: string;
  seasonYear?: number;
  seasonStartEndDisplay?: boolean;
  thisYearSesonStart?: Date;
  thisYearSesonEnd?: Date;
  locationFirstAvailableDate?: {
    leadTimeHours: number;
    addedHours: string;
  };
  isBeforeSeasonStart?: boolean;
  noAvailableBeachChairs?: boolean;
  vendor?: PublicVendorResponseDto;
  pendingAvailabilities?: boolean;
}) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation("availabilities");
  if (sectionSeasonStartInfo) {
    return (
      <Box sx={LocationAvailabilitiesBeachChairsStyle.noData}>
        <Typography
          variant={"h2"}
          sx={LocationAvailabilitiesBeachChairsStyle.noData}
        >
          Saisonstart
        </Typography>
        <Typography
          variant={"h3"}
          sx={{
            ...LocationAvailabilitiesBeachChairsStyle.noDataText,
            padding: 5,
          }}
        >
          {sectionSeasonStartInfo}
        </Typography>
      </Box>
    );
  }

  if (isBeforeSeasonStart && vendorSeasonStartInfo) {
    return (
      <Box sx={LocationAvailabilitiesBeachChairsStyle.noData}>
        <Typography
          variant={"h2"}
          sx={LocationAvailabilitiesBeachChairsStyle.noData}
        >
          Saisonstart
        </Typography>
        <Typography
          variant={"h3"}
          sx={{
            ...LocationAvailabilitiesBeachChairsStyle.noDataText,
            padding: 5,
          }}
        >
          {vendorSeasonStartInfo}
        </Typography>
      </Box>
    );
  }

  if (isBeforeSeasonStart && seasonStartDate) {
    return (
      <Box sx={LocationAvailabilitiesBeachChairsStyle.noData}>
        <Typography
          variant={"h2"}
          sx={LocationAvailabilitiesBeachChairsStyle.noData}
        >
          Saisonstart
        </Typography>
        <Typography
          variant={"h3"}
          sx={{
            ...LocationAvailabilitiesBeachChairsStyle.noDataText,
            padding: 5,
          }}
        >
          {t("bookingStartNotStartedText", {
            bookingStartDate: seasonStartDate,
            seasonYear,
          })}
        </Typography>
      </Box>
    );
  }

  if (seasonStartEndDisplay) {
    return (
      <Box sx={LocationAvailabilitiesBeachChairsStyle.noData}>
        <Typography
          variant={"h2"}
          sx={LocationAvailabilitiesBeachChairsStyle.noData}
        >
          {t("outOfSeason")}
        </Typography>
        {isValidDate(thisYearSesonStart) && isValidDate(thisYearSesonEnd) && (
          <Typography
            variant={"h3"}
            sx={{
              ...LocationAvailabilitiesBeachChairsStyle.noDataText,
              padding: 5,
            }}
          >
            {t("seasonStart")}: {thisYearSesonStart?.getDate()}.{" "}
            {t(`month.${thisYearSesonStart?.getMonth()}`)}
            {` // `}
            {t("seasonEnd")}: {thisYearSesonEnd?.getDate()}.{" "}
            {t(`month.${thisYearSesonEnd?.getMonth()}`)}
          </Typography>
        )}
        <Typography
          variant={"body1"}
          sx={LocationAvailabilitiesBeachChairsStyle.noDataText}
        >
          {t("outOfSeasonText")}
        </Typography>
      </Box>
    );
  }

  if (locationFirstAvailableDate) {
    return (
      <Box sx={LocationAvailabilitiesBeachChairsStyle.noData}>
        <Typography
          variant={"h2"}
          sx={LocationAvailabilitiesBeachChairsStyle.noData}
        >
          {t(`locationFirstAvailableDateTitle`)}
        </Typography>
        <Typography
          variant={"h3"}
          sx={{
            ...LocationAvailabilitiesBeachChairsStyle.noDataText,
            padding: 5,
          }}
        >
          {t(`locationFirstAvailableDate`, {
            time: locationFirstAvailableDate.leadTimeHours,
            date: locationFirstAvailableDate.addedHours,
          })}
        </Typography>
      </Box>
    );
  }

  if (!noAvailableBeachChairs && !pendingAvailabilities) {
    return (
      <Box sx={LocationAvailabilitiesBeachChairsStyle.noData}>
        <Typography
          variant={"h2"}
          sx={LocationAvailabilitiesBeachChairsStyle.noData}
        >
          {t(`noAvailableBeachChairsTitle`)}
        </Typography>
        <Typography
          variant={"h3"}
          sx={{
            ...LocationAvailabilitiesBeachChairsStyle.noDataText,
            padding: 5,
          }}
        >
          {t(`noAvailableBeachChairs`)}
        </Typography>
        <Card
          sx={{ maxWidth: 375, minHeight: 350, marginLeft: 1 }}
          elevation={6}
        >
          <CardContent>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              {t("contact")}
            </Typography>
            <Typography variant="h5" component="div">
              {vendor?.name}
            </Typography>
            <Typography sx={{ mb: 1.5 }} color="text.secondary">
              {t("address")}
            </Typography>
            <Typography variant="body2">
              {vendor?.address.street}
              <br />
              {vendor?.address.zip} {vendor?.address.city}
              <br />
              {vendor?.address.country}
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setShow((prev) => !prev)}
              target="_blank"
              href={`mailto:${
                vendor?.details.email
              }?bcc=info@strandbutler.de&subject=${t("onlineBooking")}&body=${t(
                "emailContent"
              )}`}
            >
              {t("email")}
            </Button>
            &nbsp;
            <Button
              variant="outlined"
              size="small"
              onClick={() => setShow((prev) => !prev)}
            >
              {t("telephone")}
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setShow((prev) => !prev)}
              target="_blank"
              href={`${vendor?.details.website}`}
            >
              {t("website")}
            </Button>
          </CardActions>
          <CardContent>
            {show && (
              <Typography variant="body2">
                <Box>{vendor?.details.email}</Box>
                <Button href={`tel:${vendor?.details.telephone}`}>
                  {vendor?.details.telephone}
                </Button>
              </Typography>
            )}
          </CardContent>
        </Card>
      </Box>
    );
  }

  /*return switchTimeline ? (
    <AvailabilitiesBeachChairTimeline />
  ) : */ return <AvailabilitiesBeachChairs />;
};

const LocationAvailabilitiesBeachChairs = () => {
  const { t } = useTranslation("availabilities");
  const mainComponentShow = useSelector(mainComponentShowSelector);
  const dispatch = useAppDispatch();
  const vendor = useSelector(getVendorSelector);
  const theme = useTheme();
  const matchesMd = useMediaQuery(theme.breakpoints.down("md"));
  const parentRef = React.useRef<HTMLDivElement>(null);
  const subSection = useSelector(getIsSubSectionsSelector);
  //const [switchTimeline, setSwitchTimeline] = useState(false);
  const start = useSelector(getDateFromSelector);
  const end = useSelector(getDateToSelector);
  const section = useSelector(getSelectedSectionSelector);
  const pendingAvailabilities = useSelector(getPendingAvailabilitiesSelector);
  const startRef = React.useRef<string>(start);
  const endRef = React.useRef<string>(end);
  const publicReference = useSelector(getPublicReferenceSelector);

  const thisYearSesonStart = formatDate(
    +start.split("-")[0],
    section?.location?.seasonStart || ""
  );
  const thisYearSesonEnd = formatDate(
    +start.split("-")[0],
    section?.location?.seasonEnd || ""
  );

  const locationFirstAvailableDate = useSelector(
    getSelectedSectionLeadTimeHoursSelector
  );

  // The backend rejects dates outside the rental season with
  // OUTSIDE_RENTAL_SEASON
  const seasonStartEndDisplay = useSelector(getOutOfSeasonSelector);
  const preBooking = getPreBookingInfo(
    vendor,
    dayjs(),
    section?.location?.seasonStart
  );
  const isBeforeSeasonStart = !!preBooking;
  const rows = useSelector(getSectionsSelector);

  React.useEffect(() => {
    if (
      section &&
      publicReference &&
      !isBeforeSeasonStart &&
      (startRef.current !== start || endRef.current !== end)
    ) {
      dispatch(
        getPublicSectionsBeachChairsAvailabilityRequest({
          publicReference,
          sectionId: section!.id,
          start,
          end,
          hasSubsections: false,
        })
      );
      startRef.current = start;
      endRef.current = end;
    }
    // eslint-disable-next-line
  }, [start, end, isBeforeSeasonStart]);

  const displayRows = useMemo(() => {
    return (
      rows.some((row) => !!row?.rowData?.length)
    );
  }, [rows]);

  if (mainComponentShow) {
    return (
      <Box
        sx={LocationAvailabilitiesBeachChairsStyle.root}
        style={vendor?.configuration.gridLineBreak ? { display: "block" } : {}}
      >
        <Box sx={LocationAvailabilitiesBeachChairsStyle.sticky} ref={parentRef}>
          <Box sx={LocationAvailabilitiesBeachChairsStyle.waterTypography}>
            <Typography sx={{ color: SBColor.blue, fontWeight: "bold" }}>{`${t(
              "water"
            )}`}</Typography>
          </Box>
          <Waves />
          {/*!isBeforeSeasonStart && displayRows ? (
            <Box sx={LocationAvailabilitiesBeachChairsStyle.switchMin}>
              <FormControlLabel
                onChange={() => {
                  setSwitchTimeline((prev) => !prev);
                }}
                value={switchTimeline}
                control={<Switch color="primary" />}
                label={
                  switchTimeline ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <Grid3x3 sx={{ color: SBColor.blue }} />
                      <Typography
                        sx={{ color: SBColor.blue, fontWeight: "bold" }}
                      >{`${t("grid")}`}</Typography>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <CalendarMonth sx={{ color: SBColor.blue }} />
                      <Typography
                        sx={{ color: SBColor.blue, fontWeight: "bold" }}
                      >{`${t("timeline")}`}</Typography>
                    </Box>
                  )
                }
                labelPlacement="end"
              />
            </Box>
          ) : null */}
          {!matchesMd && (
            <IconButton
              sx={LocationAvailabilitiesBeachChairsStyle.buttonMin}
              aria-label="minmax"
              onClick={() => {
                dispatch(mainComponentShowChangeRequest({ toggle: false }));
                dispatch(
                  setMapStateRequest({
                    mapState: subSection ? EMapState.ROWS : EMapState.BEACH,
                  })
                );
              }}
            >
              <Close />
            </IconButton>
          )}
        </Box>
        <SeasonInformation
          //switchTimeline={switchTimeline}
          seasonStartDate={preBooking?.bookingStartDate}
          seasonYear={preBooking?.seasonYear}
          sectionSeasonStartInfo={
            (section as any)?.configuration?.seasonStartInfo?.de
          }
          vendorSeasonStartInfo={
            (vendor as any)?.configuration?.seasonStartInfo?.de
          }
          seasonStartEndDisplay={seasonStartEndDisplay}
          thisYearSesonEnd={thisYearSesonEnd}
          thisYearSesonStart={thisYearSesonStart}
          locationFirstAvailableDate={locationFirstAvailableDate}
          isBeforeSeasonStart={isBeforeSeasonStart}
          noAvailableBeachChairs={displayRows}
          vendor={vendor}
          pendingAvailabilities={pendingAvailabilities}
        />
      </Box>
    );
  } else {
    return <></>;
  }
};

export default LocationAvailabilitiesBeachChairs;
